import { RouteLocationNormalized, RouteParamValue, RouteRecordRaw } from 'vue-router';
import { AppError } from '~app/core/error/app-error';

export const errorRoute: RouteRecordRaw = {
  path: '/error',
  name: 'error',
  component: () => import(/* webpackChunkName: 'error' */ './error.vue'),
  props: (route: RouteLocationNormalized) => {
    const { name, message, code } = <Record<string, RouteParamValue>>route.params;
    return { error: code ? new AppError(name, message, code) : void 0 };
  },
  meta: {
    public: true,
  },
};
